import React from 'react'

import { FormSubmitErrorsProps } from '../../form/FormSubmitErrors'
import { TextFieldProps } from '../../form/TextField'
import FormikField from '../../form/FormikField'
import { SubmitButtonProps } from '../../form/SubmitButton'
import { FormikFormProps } from '../../form/FormikForm'

import * as SC from './styled'

export type LoginFormValues = {
  email: string
}

export type ForgotPasswordFormProps = {
  className?: string
  formik: FormikFormProps<LoginFormValues>
  fields: {
    email: TextFieldProps
  }
  title: string
  desc: string
  successMessage?: string
  submitErrors?: FormSubmitErrorsProps['errors']
  submitButton: SubmitButtonProps
}

const ForgotPasswordForm: React.FC<ForgotPasswordFormProps> = ({
  className,
  formik,
  fields,
  title,
  desc,
  successMessage,
  submitErrors,
  submitButton,
}) => {
  return (
    <SC.Form {...formik} className={className}>
      <SC.Title>{title}</SC.Title>
      <SC.Text>{desc}</SC.Text>
      {!successMessage && (
        <>
          <FormikField {...fields.email} Component={SC.TextField} />
          {submitErrors && <SC.SubmitErrors errors={submitErrors} />}
          <SC.Submit {...submitButton} />
        </>
      )}
      {successMessage && <SC.SuccessMessage>{successMessage}</SC.SuccessMessage>}
    </SC.Form>
  )
}

export default ForgotPasswordForm
